import { graphql, useStaticQuery } from 'gatsby';
import HeadingAndImageCardList from 'molecules/HeadingAndImageCardList/HeadingAndImageCardList';
import { ImageCardProps } from 'molecules/ImageCard/ImageCard';
import React from 'react';
import { IStaticContentfulImages } from 'src/types/contentful';
import Stack from 'atoms/Layout/Stack/Stack';
import Button from 'atoms/Button/Button';

const PlansEveryStageCardsList = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      launchImage: contentfulAsset(contentful_id: { eq: "67TCAklOO0XsfQAzbGgOEd" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      scaleImage: contentfulAsset(contentful_id: { eq: "47XqOnvIzA8OyZb2nXPok6" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      growthImage: contentfulAsset(contentful_id: { eq: "3fIa6ggXPXqkRsPY986kub" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
    }
  `);

  const baseImageCardHeadingProps = {
    type: 'paragraph',
    size: 'xl',
    fontWeight: 'font-weight-semibold',
    color: 'text-primary',
  };

  const baseImageCardSupportingTextProps = {
    type: 'paragraph',
    size: 'md',
    color: 'text-tertiary',
  };

  const imageCards = [
    {
      href: '/pricing/launch',
      background: 'bg-primary-alt',
      image: {
        image: images.launchImage.gatsbyImageData,
        alt: 'Launch Plan',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Launch Plan',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'Get your first 10 members in 30 days.',
      },
    },
    {
      href: '/pricing/scale',
      background: 'bg-primary-alt',
      image: {
        image: images.scaleImage.gatsbyImageData,
        alt: 'Scale Plan',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Scale Plan',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'Migrate your business or add a new revenue stream.',
      },
    },
    {
      href: '/pricing/growth',
      background: 'bg-primary-alt',
      image: {
        image: images.growthImage.gatsbyImageData,
        alt: 'Growth Plan',
      },
      title: {
        ...baseImageCardHeadingProps,
        text: 'Growth Plan',
      },
      supportingText: {
        ...baseImageCardSupportingTextProps,
        text: 'Dedicated support to grow faster.',
      },
    },
  ] as ImageCardProps[];

  return (
    <Stack
      direction='column'
      justify='center'
      align='center'
      gap='spacing-7xl'
      gapSm='spacing-4xl'
    >
      <HeadingAndImageCardList
        align='center'
        headingAndSupportingText={{
          heading: {
            type: 'heading',
            size: 'xl',
            text: 'Plans for Every Stage',
            fontWeight: 'font-weight-semibold',
            letterSpacing: -1,
            textAlign: 'center',
            color: 'text-primary',
          },
          supportingText: {
            type: 'paragraph',
            size: 'xl',
            text: "Whether you're launching your first community or scaling to millions, there's a plan built to meet you where you are—and where you want to go next.",
            color: 'text-tertiary',
            textAlign: 'center',
          },
          maxWidth: 'width-xl',
        }}
        imageCards={imageCards}
        totalColumns={3}
        totalColumnsLg={3}
        totalColumnsSm={1}
      />
      <Stack maxWidth='width-fit-content'>
        <Button
          variant='primary'
          size='xl'
          href='/pricing'
        >
          Compare Plans
        </Button>
      </Stack>
    </Stack>
  );
};

export default PlansEveryStageCardsList;
